import { render, staticRenderFns } from "./plattaskaccept-add-or-update.vue?vue&type=template&id=8f604c08&"
import script from "./plattaskaccept-add-or-update.vue?vue&type=script&lang=js&"
export * from "./plattaskaccept-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports